import { withWizardRefetch } from "../withWizardRefetch.js";
import {
  useSetItemPlaceholderForTemplateTypeMutation,
  useTemplateTypePlacerholderQuestionControlForm_ModifyWizardSettingsMutation,
} from "./TemplateTypePlaceholderBox.generated.js";

export const useSetItemPlaceholderForTemplateTypeMutationWithWizardRefetch =
  withWizardRefetch(useSetItemPlaceholderForTemplateTypeMutation);

export const useTemplateTypePlacerholderQuestionControlForm_ModifyWizardSettingsMutationWithWizardRefetch =
  withWizardRefetch(
    useTemplateTypePlacerholderQuestionControlForm_ModifyWizardSettingsMutation
  );
